import { createSelector } from 'reselect';
import { getEntitySelector } from '../selectors';
import { ENTITIES_KEY_LOGO } from './index';

export const getLogoEntities = (state) => getEntitySelector(state, ENTITIES_KEY_LOGO);

export const getLogos = createSelector(getLogoEntities, (logoEntities) => {
    if (!logoEntities) {
        return [];
    }
    const { allIds = [], ...logos } = logoEntities;
    return allIds.map((logoId) => logos[logoId]);
});
